import {
  NOTIFICATIONS_ALL,
  NOTIFICATIONS_ALL_SUCCESS,
  NOTIFICATIONS_ALL_UNREAD,
  NOTIFICATIONS_ALL_UNREAD_SUCCESS,
  NOTIFICATIONS_GET,
  NOTIFICATIONS_GET_SUCCESS,
  NOTIFICATIONS_LAST,
  NOTIFICATIONS_LAST_SUCCESS,
  NOTIFICATIONS_MARK_READ,
  NOTIFICATIONS_UNREAD,
  NOTIFICATIONS_UNREAD_SUCCESS,
} from '../constants/Notifications';

export const getNotifications = (perPage, page) => ({
  type: NOTIFICATIONS_ALL,
  perPage,
  page,
});

export const getNotificationsSuccess = (notifications, total, from, to) => ({
  type: NOTIFICATIONS_ALL_SUCCESS,
  notifications,
  total,
  from,
  to,
});

export const getNotification = (id) => ({
  type: NOTIFICATIONS_GET,
  id,
});

export const getNotificationSuccess = (notification) => ({
  type: NOTIFICATIONS_GET_SUCCESS,
  notification,
});

export const getUnreadNotifications = () => ({
  type: NOTIFICATIONS_UNREAD,
});

export const getUnreadNotificationsSuccess = (unread) => ({
  type: NOTIFICATIONS_UNREAD_SUCCESS,
  unread,
});

export const getAllUnreadNotifications = () => ({
  type: NOTIFICATIONS_ALL_UNREAD,
});

export const getAllUnreadNotificationsSuccess = (unreadNotifications) => ({
  type: NOTIFICATIONS_ALL_UNREAD_SUCCESS,
  unreadNotifications,
});

export const setAsRead = (notification) => ({
  type: NOTIFICATIONS_MARK_READ,
  notification,
});

export const getLastNotifications = (count) => ({
  type: NOTIFICATIONS_LAST,
  count,
});

export const getLastNotificationsSuccess = (lastNotifications) => ({
  type: NOTIFICATIONS_LAST_SUCCESS,
  lastNotifications,
});
